<div #contentDiv class="max-w-lg mx-auto flex flex-col pt-20 min-h-[calc(100vh)]">
  <div class="flex-1 bg-theme-surface rounded-t-3xl min-h-full p-4 text-theme-text">
    <div class="flex items-center space-x-4">
      <app-circle-button [icon]="'fa-chevron-left'" size="12" type="solid" fontSize="xl"
        (onClick)="back()"></app-circle-button>
      <div class="text-lg text-theme-text font-semibold">GDPR</div>
    </div>

    <div class="flex-1 bg-theme-surface min-h-full pt-4">
      <div class="space-y-6">
        <!-- Introduktion -->
        <p class="text-base text-theme-text">
          Din integritet och förtroende är av högsta prioritet för oss. Här följer en sammanfattning av eventuell
          personlig information som kan samlas in.
        </p>

        <div class="space-y-6">
          <!-- Huvudrubrik -->
          <h2 class="text-2xl font-bold text-theme-text">Beställning via webben</h2>

          <!-- Beställning genom Messenger-profil -->
          <h3 class="text-xl font-semibold text-theme-text mt-4">Beställning genom Messenger-profil</h3>
          <ul class="list-disc pl-6 text-theme-text">
            <li>Vid användning av Messenger skapas en unik profil för varje restaurang du besöker.</li>
            <li>Profilen lagrar namn och bild från den offentliga informationen i ditt Messenger-konto.</li>
          </ul>

          <!-- Inloggad beställning med profil -->
          <h3 class="text-xl font-semibold text-theme-text mt-4">Inloggad beställning med profil</h3>
          <ul class="list-disc pl-6 text-theme-text">
            <li>Vid inloggning skapas en profil, och i den lagras e-post, namn och profilbild som hämtas från det
              användarkonto som användes för inloggning.</li>
            <li>Om gästen använder ett Apple-konto har de möjlighet att välja vilka uppgifter som delas. I grundutförande
              delas inte e-post eller namn.</li>
          </ul>

          <!-- Anonym beställning utan profil -->
          <h3 class="text-xl font-semibold text-theme-text mt-4">Anonym beställning utan profil</h3>
          <ul class="list-disc pl-6 text-theme-text">
            <li>Vissa restauranger tillåter beställningar utan inloggning.</li>
            <li>Ingen personlig information lagras i dessa fall.</li>
          </ul>
        </div>

        <!-- Vilka uppgifter lagras vid köp? -->
        <h2 class="text-2xl font-bold text-theme-text mt-6">Vilka uppgifter lagras vid köp?</h2>
        <ul class="list-disc pl-6 text-theme-text">
          <li>Kvittot visar vilka artiklar som har köpts.</li>
          <li>Vid kortbetalning lagras de sista fyra siffrorna av kortnumret.</li>
          <li>Vid betalning med Swish lagras de sista fyra siffrorna av ditt telefonnummer.</li>
          <li>Swish-referensdata lagras med extra kryptering.</li>
          <li>Vid takeaway eller leverans sparas det telefonnummer och adress du angav. Denna data raderas automatiskt
            efter 3 år eller när profilen raderas.</li>
          <li>
            Du hittar din köphistorik här:
            <a href="#" class="underline hover:underline" (click)="navtoReceipts()">kvitton</a>
          </li>
        </ul>

        <!-- Händelser -->
        <h2 class="text-2xl font-bold text-theme-text mt-6">Händelser</h2>
        <ul class="list-disc pl-6 text-theme-text">
          <li>Systemet skickar notiser om händelser vid användning i form av chattmeddelanden.</li>
          <li>Vissa händelser kan innehålla personlig information, som ditt namn.</li>
          <li>
            Händelser raderas automatiskt efter 3 år, men kan även
            <a href="#" class="underline hover:underline" (click)="cleanEvents(); $event.preventDefault()">rensas manuellt</a>.
          </li>
          <li>Händelser sparas inte för messenger-profiler.</li>
        </ul>

        <!-- Hur används profiluppgifterna? -->
        <h2 class="text-2xl font-bold text-theme-text mt-6">Hur används profiluppgifterna?</h2>
        <ul class="list-disc pl-6 text-theme-text">
          <li><span class="font-semibold">Namn:</span> Visas endast i samband med köp och beställning för att ge bättre service.</li>
          <li><span class="font-semibold">E-post:</span> Används av systemet för att skicka notifikationer i samband med köp, som t.ex. kvitto och att order är färdig.</li>
          <li><span class="font-semibold">Telefonnummer/Adress:</span> Används vid köp som kräver kontakt med beställaren. Enbart synliga vid köptillfället.</li>
          <li><span class="font-semibold">Händelser:</span> Sparas enbart för att ge användarna en översikt över tidigare händelser.</li>
        </ul>

        <div class="space-y-6">
          <!-- Rubrik -->
          <h2 class="text-2xl font-bold text-theme-text">Din profil</h2>

          <!-- Profilkort -->
          <div *ngIf="profileInfo" class="bg-theme-surface2 rounded-lg shadow p-6">
            <div class="flex items-center">
              <!-- Profilbild -->
              <img
                *ngIf="profileInfo.image"
                [src]="profileInfo.image"
                alt="Profilbild"
                class="w-24 h-24 rounded-full">

              <!-- Profilinformation -->
              <div class="ml-8 text-theme-text">
                <div class="mb-2">
                  <span class="font-semibold">Namn:</span> {{profileInfo.name}}
                </div>
                <div>
                  <span class="font-semibold">E-post:</span> {{profileInfo.email}}
                </div>
              </div>
            </div>
          </div>
        </div>


      <div class="space-y-6">
        <!-- Rubrik -->
        <h2 class="text-2xl font-bold text-theme-text mt-8">Radera profilen</h2>

        <!-- Punktlista -->
        <ul class="list-disc pl-6 text-theme-text">
          <li>Profil och alla händelser kommer att raderas.</li>
          <li>Köphistorik kommer inte längre att kopplas till profilen och blir anonym.</li>
          <li>Köphistorik kan inte återställas.</li>
          <li>Alla rabattkoder tas bort.</li>
          <li>Eventuella presentkort/rabattkort tas bort.</li>
          <li>Det kan ta upp till 30 dagar innan all personlig information är raderad eller anonymiserad.</li>
        </ul>

        <!-- Knapp -->
        <div class="mt-8">
          <button
            class="px-6 py-3 bg-red-600 text-white font-semibold rounded-lg shadow hover:bg-red-700 transition w-full md:w-auto"
            (click)="wipeProfile()">
            {{getString("Radera profil", "upper")}}
          </button>
        </div>
      </div>



    </div>
    <div *ngIf="isLoading"
      class="fixed top-0 bottom-0 left-0 right-0 bg-theme-surface-80 p-4 pb-safe z-10 flex items-center justify-center">
      <app-loading-spinner size="xl"></app-loading-spinner>
    </div>

  </div>
